<template>
    <div class="find-dealership--map-wrapper">
        <div class="find-dealership--map-overlay" v-if="showOverlay">
            <p>Select a distributor from the menu</p>
        </div>
        <div class="find-dealership--map" ref="map"></div>
    </div>
</template>

<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import mapTheme from '../data/mapTheme.js'

let markers = []
let clusterer;

export default {
    props: {
        input: Array 
    },
    data() {
        return {
            distributors: [],
            distributorIds: [],
            markers: [],
            showOverlay: true,
            latlng: {
                lat: -41.35458624011251,
                lng: 172.3361986978373
            },
            map: undefined,
            zoom: 6,
        }
    },
    mounted() {

        // this.setZoom()

        this.distributors = this.input

        this.map = new this.$google.maps.Map(this.$refs.map, {
            center: this.latlng,
            zoom: this.zoom,
            // disableDefaultUI: true,
            // draggable: false,
            styles: mapTheme
        })

        this.setupMarkers()

        // this.map.addListener('click', () => {
        //     console.log(this.map.center.lat())
        //     console.log(this.map.center.lng())
        //     console.log(this.map.getZoom)
        // })

        this.$bus.on('updateDistributors', this.updateDistributors)
        this.$bus.on('showInfo', this.showInfo)
        this.$bus.on('zoomMap', this.zoomMap)

        window.addEventListener('resize', () => {
            this.setZoom()
        })

    },
    methods: {
        setZoom() {
            if (window.innerWidth < 768) {
                this.zoom = 5
            } else {
                this.zoom = 6;
            }
        },
        setupMarkers() {

            const base = '_resources/themes/livi/build/images/icons/'

            markers = Array.from(this.distributors).map(distributor => {

                return new this.$google.maps.Marker({
                    data: distributor,
                    icon: {
                        url: `${base}MapPin.svg`,
                        scaledSize: new this.$google.maps.Size(50, 50)
                    },
                    position: this.helpers.stringToCoord(distributor.LatLng),
                })
            })

            this.updateDistributors(this.distributors, false)
        },
        toggleMarkers() {

            markers.forEach(marker => {

                if (this.distributorIds.indexOf(marker.data.ID) > -1) {
                    marker.setMap(this.map)
                } else {
                    marker.setMap(null)
                }

                marker.addListener('click', () => {
                    this.showInfo(marker.data)
                })
            })
        },
        zoomMap(options) {

            let latlng = this.latlng 


            if (!options) {
                options = {
                    zoom: 6
                }
            }

            if (options && options.latlng) {
                latlng = this.helpers.stringToCoord(options.latlng)
            }

            this.map.setZoom(options.zoom)
            this.map.panTo(latlng)
        },
        updateDistributors(data, toggleMarkers = true) {
            this.distributors = Array.from(data)
            this.distributorIds = this.distributors.map(d => d.ID)

            if (toggleMarkers) {
                this.showOverlay = false
                this.toggleMarkers()
            }
        },
        showInfo(distributor) {

            markers.forEach(marker => {
                if (marker.info) {
                    marker.info.close()
                }
            })

            const marker = markers.find(marker => {
                return marker.data.ID === distributor.ID
            })

            const info = new this.$google.maps.InfoWindow({
                content: `
                    <div class="distributor-info">
                        <div class="distributor-info__content-wrapper">
                            <div class="distributor-info__content">
                                <div class="distributor-info__title">
                                    ${distributor.Title}
                                </div>
                                <div class="distributor-info__address">
                                    <p class="distributor-info__street">${distributor.Address}</p>
                                    <p class="distributor-info__region">${distributor.Region}, ${distributor.City}</p>
                                    <p class="distributor-info__postcode">${distributor.Postcode}</p>
                                    <div class="distributor-info__links">
                                        <p class="distributor-info__phone">
                                            <a href="tel:${distributor.Phone}">${distributor.Phone}</a>
                                        </p>
                                        <p class="distributor-info__website">
                                            <a href="${distributor.Website}" target="_blank">Visit Website</a>
                                        </p>
                                    </div>
                                    <p class="distributor__info-directions"><a href="https://www.google.com/maps/dir//${distributor.Address}, ${distributor.Region}" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                          <g transform="translate(3.759 1.716)">
                                            <path d="M8.242,20.568a.681.681,0,0,1-.475-.194C5.945,18.62,0,12.588,0,8.56A8.416,8.416,0,0,1,8.243,0a8.038,8.038,0,0,1,5.828,2.508A8.662,8.662,0,0,1,16.483,8.56c0,4.025-5.945,10.06-7.767,11.813A.679.679,0,0,1,8.242,20.568Zm0-16.375A3.9,3.9,0,0,0,4.423,8.16a3.9,3.9,0,0,0,3.821,3.967A3.9,3.9,0,0,0,12.065,8.16,3.9,3.9,0,0,0,8.243,4.193Z" transform="translate(0 0)" fill="#59C638"/>
                                          </g>
                                        </svg>
                                    Get Directions
                                    </a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                `,
            });

            marker.info = info

            info.open({
                anchor: marker,
                map: this.map
            })
        }
    }
}
</script>

